import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  workflowStepAll: [],
  workflowStep: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const workflowStepSlice = createSlice({
  name: "workflowStep",
  initialState,
  reducers: {
    setWorkflowStepAll: (state, action) => {
      state.workflowStepAll = action.payload;
    },
    setWorkflowStep: (state, action) => {
      state.workflowStep = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setWorkflowStepAll,
  setWorkflowStep,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = workflowStepSlice.actions;

export default workflowStepSlice.reducer;
